import { signOut } from "firebase/auth";
import type { User } from "firebase/auth";
import { auth } from "../lib/firebase";

interface UserBarProps {
  user: User;
}

export function UserBar({ user }: UserBarProps) {
  return (
    <>
      {user.email}{" "}
      <button className="secondary" onClick={() => signOut(auth)}>
        Logout
      </button>
    </>
  );
}
